'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

var _dofIconfont = require('../dof-iconfont');

var _dofIconfont2 = _interopRequireDefault(_dofIconfont);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = weex.requireModule('dom'); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icon = require('../setting/icon.base64.js');
// var CHECKED = icon['public_ic_done@2x'];
// var UNCHECKED = icon['unchecked'];
// var CHECKED_DISABLED = icon['dischecked'];
// var UNCHECKED_DISABLED = icon['disuncheked'];
var UNCHECKED = icon['icon_checkbox_unselect'];
var UNCHECKEDDIABLO = icon['icon_checkbox_unselect_diablo'];
var CHECKED = icon['icon_checkbox_selected'];
var CHECKEDDIABLO = icon['icon_checkbox_selected_diablo'];
var ARROW_ICON = icon['public_ic_more@3x'];
var WIDTH = 498; // hack
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  components: { DofIconfont: _dofIconfont2.default },
  props: {
    hasTopBorder: {
      type: Boolean,
      default: false
    },
    hasSubTopBorder: {
      type: Boolean,
      default: false
    },
    hasBottomBorder: {
      type: Boolean,
      default: false
    },
    hasSubBottomBorder: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      require: true
    },

    tag: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Object],
      require: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    desc: {
      type: String,
      default: ''
    },
    itemImg: {
      type: String,
      default: ''
    },
    hasArrow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      innerChecked: false,
      isOverflow: false,
      titleWidth: 0,
      tagWidth: 0
    };
  },
  watch: {
    title: {
      handler: function handler(newValue, oldValue) {
        var _this = this;

        if (newValue) {
          this.$nextTick(function () {
            _this.isOverflow = _this.titleWidth + _this.tagWidth > WIDTH;
          });
        }
      },

      immediate: true
    }
  },
  created: function created() {
    var checked = this.checked,
        disabled = this.disabled;

    this.innerChecked = checked;
  },

  computed: {
    icon: function icon() {
      return [this._isDiablo ? CHECKEDDIABLO : CHECKED, this._isDiablo ? UNCHECKEDDIABLO : UNCHECKED];
    },
    checkIcon: function checkIcon() {
      var icon = this.icon,
          disabled = this.disabled,
          innerChecked = this.innerChecked;

      return icon[innerChecked ? 0 : 1];
    },

    // item动态高度 由desc撑开
    // dynamicSizeComp() {
    //   if (this.itemImg) {
    //     return {
    //       height: '160px'
    //     }
    //   } else {
    //     return { }
    //   }
    // },
    dynamicSizeComp: function dynamicSizeComp() {
      if (this.desc || this.itemImg) {
        return {
          height: '160.5px' //有subtitle或者图片时的高度
        };
      } else {
        return {
          // height: '80px'   ////无subtitle和无图片时的高度
        };
      }
    },
    cellDynamicHeight: function cellDynamicHeight() {
      if (!this.desc && !this.itemImg) {
        return {
          // height: '82px' ////无subtitle和无图片时的高度
        };
      }
      return {};
    },
    titleDynamicHeight: function titleDynamicHeight() {
      if (!this.desc && !this.itemImg) {
        return {
          height: this._isColmo ? '104px' : '80px' ////无subtitle和无图片时的高度
        };
      }
      return {};
    }
  },

  methods: {
    dofCellClick: function dofCellClick() {
      var disabled = this.disabled,
          innerChecked = this.innerChecked,
          value = this.value;

      if (!disabled) {
        this.innerChecked = !innerChecked;
        this.$emit('dofCheckBoxItemChecked', { value: value, checked: this.innerChecked });
      }
    },
    dynamicIsOverflow: function dynamicIsOverflow() {
      var _this2 = this;

      // ios下面 对于这个动态的设置flex=1,或者max-width都会 偶现不生效。
      this.$nextTick(function () {
        setTimeout(function () {
          var result = dom.getComponentRect(_this2.$refs.tagBox, function (option) {
            var result2 = dom.getComponentRect(_this2.$refs.titleBox, function (titleResult) {
              _this2.titleWidth = titleResult.size && titleResult.size.width;
              _this2.tagWidth = option.size && option.size.width;
              _this2.isOverflow = _this2.titleWidth + _this2.tagWidth > WIDTH;
            });
          });
        }, 60);
      });
    }
  },
  mounted: function mounted() {
    this.dynamicIsOverflow();
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-checkbox/index.vue
// module id = 314
// module chunks = 0 1